<template>
  <div>
    <app-warp title='云店模板' type="mini">
      <template #app-content>
        <div style="min-height:100%;background-size:100% 100%;" :style="'background-image:url('+oss+pageSet.award.index.style.backgroundImage+')'" class="moduleMain">
          <template v-for="(item,key) in pageSet.award" :key="key">
            <div @click.stop="selectModule(key)" v-if="activeKey==key">
              <component :is="key" :data="item" />
            </div>
          </template>
        </div>
      </template>
      <template #app-sider>
        <a-radio-group v-model:value="activeKey" button-style="solid" @change="changePage" class="m-b-20 m-l-20">
          <a-radio-button value="index">首页</a-radio-button>
          <a-radio-button value="win">中奖页</a-radio-button>
          <a-radio-button value="fw">防伪</a-radio-button>
          <a-radio-button value="repeatFw">重复查询</a-radio-button>
          <a-radio-button value="repeat">重复领奖</a-radio-button>
          <a-radio-button value="collect">收集资料</a-radio-button>
          <a-radio-button value="notWinning">未中奖</a-radio-button>
          <a-radio-button value="double">翻倍</a-radio-button>
        </a-radio-group>
        <div class="moduleContent " style="width:100%;margin-left:20px">
          <a-form :model="form" ref='ruleForm' :label-col="{span:4}" :wrapper-col="{span:18}">
            <template v-for="(value,index) in formCreateData" :key="index">
              <a-form-item :label="value.label" :help="value.help">
                <!-- 普通表单 -->
                <template v-if="value.stamp=='input'">
                  <a-row :gutter="16">
                    <a-col :span="10">
                      <a-input v-model:value="modelRef[value.key][value.name]" :type="value.type" :help="value.help" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认设置</a>
                    </a-col>
                  </a-row>
                </template>
                <template v-if="value.stamp=='query'">
                  <a-input-search style="width:200px" v-model:value="modelRef[value.key][value.name]" @search="childrenIndex=indexs;fwVisible=true" readonly placeholder="默认模板">
                    <template #enterButton>
                      <a-button type="primary">
                        选择
                      </a-button>
                    </template>
                  </a-input-search>
                </template>

                <!-- 选择框 -->
                <template v-if="value.stamp=='select'">
                  <a-select v-model:value="modelRef[value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
                    <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
                    </a-select-option>
                  </a-select>
                </template>
                <template v-if="value.stamp=='singleImage'">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <material :groupType='1' :image="modelRef[value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{
                    modelRef[value.key][value.name]=data}" v-on:handledel="modelRef[value.key][value.name]=''" />
                    </a-col>
                    <a-col :span="12" v-if="value.defaultValue">
                      <a href="javascript:;" v-if="value.defaultValue" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认图</a>
                    </a-col>
                  </a-row>
                </template>
                <!-- 单选框 -->
                <template v-if="value.stamp=='radio'">
                  <a-radio-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
                </template>
              </a-form-item>
            </template>
          </a-form>
        </div>
      </template>
    </app-warp>
    <!-- 关联模板 -->
    <a-modal :keyboard="false" title="关联模板" centered v-model:visible="fwVisible" @ok="fwVisible=false" style="width:1200px" :width="1200">
      <fwAudiSelect v-on:select="selecFwAudi" />
    </a-modal>
  </div>
</template>

<script>
import fw from "./components/fw.vue";
import win from "./components/win.vue";
import repeatFw from "./components/repeatFw.vue";
import repeat from "./components/repeat.vue";
import double from "./components/double.vue";
import collect from "./components/collect.vue";
import index from "./components/index.vue";
import notWinning from "./components/notWinning.vue";
import config from "@/config";
import forms from "./form";
import * as Icon from "@ant-design/icons-vue";
import { onMounted, reactive, ref, toRefs, watch, watchEffect } from "vue";
import {getCanvas} from '@/libs/html2canvas'
export default {
  components: {
    fw,
    win,
    repeatFw,
    repeat,
    collect,
    double,
    index,
    notWinning,
    ...Icon,
  },
  name: "normal",
  props: {
    template_data: Object,
  },
  setup(props, { emit }) {
    // 模板页当前页面 记录
    const state = reactive({
      active: "index",
      fwVisible: false,
    });
    const activeKey = ref("index");

    var pageSet = ref({
      award: {
        index: {
          style: {
            backgroundImage: "/web_base_assets/scan/store_default_tp.png",
            btnBackgroundImage: "/web_base_assets/scan/store_open.png",
            backgroundColor: "#ff2419",
          },
          params:{
            title:"云店模板"
          }
        },
        win: {
          style: {
            titleColor: "#F4261F",
            color: "#F4261F",
            des_color: "#F4261F",
            btn_color: "#F4261F",
          },
        },
        fw: {
          style: {
            icon: "/web_base_assets/scan/first_fw.png",
            color: "#EF8537",
          },
          params: {
            antis_fake_tem_title: "",
            antis_fake_tem_id: "",
          },
        },
        repeat: {
          style: {
            backgroundImage: "/web_base_assets/scan/store_template_poup.png",
            color: "#EF8537",
            title_color: "#EF8537",
            backgroundColor:""
          },
        },
        notWinning: {
          style: {
            backgroundImage: "/web_base_assets/scan/store_template_poup.png",
            title_color: "#F4261F",
            backgroundColor:''
          },
        },
        repeatFw: {
          style: {
            icon: "/web_base_assets/scan/second_fw.png",
            color: "#EF8537",
          },
          params: {
            antis_fake_tem_title: "",
            antis_fake_tem_id: "",
          },
        },
        collect: {
          style: {
            titleColor: "#333333",
            desColor: "#999999",
            backgroundImage: "",
            backgroundColor: "#ffffff",
            buttonColor: "#FF0E41",
            buttonTextColor: "#ffffff",
            backgroundButtomImage: "",
          },
        },
        double: {
          style: {
            backgroundImage: "/web_base_assets/scan/double.gif",
            color: "#FDE1A2",
          },
          params: {
            tips: "尊贵的会员 您的奖项已倍增",
          },
        },
      },
    });
    watchEffect(() => {
      if (JSON.stringify(props.template_data) != "{}") {
        pageSet.value = props.template_data;
      }
    });
    const activeData = ref({
      is_show: false,
      title: "扫码有礼",
      wait_time: 3,
      backgroundImage: "/web_base_assets/scan/background_default.png",
      backgroundColor: "#fc8c35",
      type: "welcome",
    });
    var modelRef = ref();
    const moduleIndex = ref(0);
    // 读取模块表单数据
    var formCreateData = ref({});
    const formCreate = () => {
      forms.forEach((element) => {
        if (element.type == state.active) {
          formCreateData.value = element.formItems;
        }
      });
      console.log(formCreateData.value);
    };
    // 模块
    const selectModule = (type) => {
      modelRef.value = pageSet.value.award[type];
      state.active = type;
      formCreate();
    };
    const initData = () => {
      formCreate();
    };
    const oss = config.oss[process.env.VUE_APP_type];
    onMounted(() => {
      selectModule(activeKey.value);
      initData();
    });
    const submit = () => {
      emit("submit", pageSet.value);
      return pageSet.value;
    };
        const getThumb = () => {
          // 选中首页 用于截图
        return new Promise((resolve,reject)=>{
            // 选中首页 用于截图
          activeKey.value='index'
          var element= document.getElementById('app-subject')
          getCanvas(element).then(res=>{
              resolve(res.image)
          }).catch(()=>{
              reject(pageSet.value.award["index"].style.backgroundImage)
          })
      })
      // return "";
    };
    const changePage = (e) => {
      state.value = e.target.value;
      selectModule(activeKey.value);
      formCreate();
    };
    const selecFwAudi = (data) => {
      pageSet.value.award["fw"].params.antis_fake_tem_id = data.id;
      pageSet.value.award["fw"].params.antis_fake_tem_title = data.name;
      pageSet.value.award["repeatFw"].params.antis_fake_tem_id = data.id;
      pageSet.value.award["repeatFw"].params.antis_fake_tem_title = data.name;
      state.fwVisible = false;
    };
    return {
      activeKey,
      pageSet,
      selectModule,
      activeData,
      formCreateData,
      ...toRefs(state),
      modelRef,
      moduleIndex,
      oss,
      submit,
      getThumb,
      changePage,
      selecFwAudi,
    };
  },
};
</script>
<style lang="less" scoped>
@import url("../module.less");
</style>